module.exports = __webpack_public_path__ + "static/img/topright_2.eff18a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/topright_2.png
// module id = NULA
// module chunks = 1